<template>
  <div>
    <div class="chat-index">
      <div class="row">
        <div class="col-md-4" style="padding-right: 0px;">
          <div class="chat-sidebar">
            <h3>Chats</h3>
            <input type="text" placeholder="Search conversations">
            <div class="tabs">
            <h6 class="ongoing-con" :class="{ actTab: activeTab === 'unresolved' }" @click="activeTab = 'unresolved'">Unresolved ({{ unresolvedCount }})</h6>
            <h6 class="ongoing-con" :class="{ actTab: activeTab === 'resolved' }" @click="activeTab = 'resolved'">Resolved ({{ resolvedCount }})</h6>
            <!-- <h6 class="ongoing-con" style="margin-right: 0px;" :class="{ actTab: activeTab === 'admin' }" @click="activeTab = 'admin'">Admin ({{ adminCount }})</h6> -->
          </div>
          <div class="clearfix"></div>
      <!-- Chat List -->
      <div class="chat-box">
        <!-- Unresolved -->
        <div v-if="activeTab === 'unresolved'">
          <div v-for="chatUser in unresolvedUsers" :key="chatUser.id">
            <div class="chatBox" :class="{ active: $route.params.userId == chatUser.id }" v-if="chatUser.chat != 'Admin chat'">
              <router-link :to="'/sadmin/user-chat/' + chatUser.id">
                <div class="row">
                  <div class="col-md-3" style="padding-right: 11px;">
                    <img v-if="chatUser.image" :src="chatUser.image" />
                    <img v-else src="/img/userChat.png" />
                  </div>
                  <div class="col-md-9" style="padding-left: 0px;">
                    <h5>{{ chatUser.name }}</h5>
                    <h6>
                      <span v-if="chatUser.isReceived == 1" class="userRep"></span>
                      <img v-else src="/img/LeftReply.png" style="margin-right: 2px;" />
                      {{ chatUser.chat }}
                    </h6>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <!-- Resolved -->
        <div v-if="activeTab === 'resolved'">
          <div v-for="chatUser in resolvedUsers" :key="chatUser.id">
            <div class="chatBox" :class="{ active: $route.params.userId == chatUser.id }">
              <router-link :to="'/sadmin/user-chat/' + chatUser.id">
                <div class="row">
                  <div class="col-md-3" style="padding-right: 11px;">
                    <img v-if="chatUser.image" :src="chatUser.image" />
                    <img v-else src="/img/userChat.png" />
                  </div>
                  <div class="col-md-9" style="padding-left: 0px;">
                    <h5>{{ chatUser.name }}</h5>
                    <h6>
                      <span v-if="chatUser.isReceived == 1" class="userRep"></span>
                      <img v-else src="/img/LeftReply.png" style="margin-right: 2px;" />
                      {{ chatUser.chat }}
                    </h6>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 'admin'">
          <div v-for="chatUser in AdminData" :key="chatUser.id">
            <div class="chatBox" :class="{ active: $route.params.userId == chatUser.id }" v-if="chatUser.chat == 'Admin chat'">
              <router-link :to="'/sadmin/user-chat/' + chatUser.id">
                <div class="row">
                  <div class="col-md-3" style="padding-right: 11px;">
                    <img v-if="chatUser.image" :src="chatUser.image" />
                    <img v-else src="/img/userChat.png" />
                  </div>

                  <div class="col-md-9" style="padding-left: 0px;">
                    <h5>{{ chatUser.name }}</h5>
                    <h6>
                      <span v-if="chatUser.isReceived == 1" class="userRep"></span>
                      <img v-else src="/img/LeftReply.png" style="margin-right: 2px;" />
                      {{ chatUser.chat }}
                    </h6>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
            </div>
          </div>
        <div class="col-md-8" style="padding-left: 0px;">
          <div class="chatHeader">
            <div class="row">
              <div class="col-md-2" style="padding-right: 0px;">
                <img v-if="user.image" :src="user.image" style="width: 90px;border-radius: 50%; height: 90px;" />
                <img v-else src="/img/userChat.png" style="max-width: 80%;" />
              </div>
              <div class="col-md-5" style="padding-left: 0px;">
                <h4>{{ user.name }}</h4>
                <h6>{{ user.email }}</h6>
              </div>
              <div class="col-md-5" style="text-align: right;padding-top: 25px;">
                <!--<button v-if="ChatStatus.status == 0" @click="MarkAsResolved">Mark As Resolved</button>
                <button v-else>Resolved</button> -->
                <!-- <a href="#"><img src="/img/threeDot.png" style="max-width: 80%;width: 40px;"/></a> -->
                <label class="switch">
                  <input type="checkbox" v-model="ChatStatus.status" @change="MarkAsResolved">
                  <span class="slider"></span>
                </label>
                <span>{{ ChatStatus.status == 1 ? ' Resolved' : ' Unresolved' }}</span>
              </div>
            </div>
          </div>
          <div class="chatList">
            <div v-for="(chatHistory, index) in chatHistories" :key="index">
              <h6 v-if="index === 0 || chatHistory.date !== chatHistories[index - 1].date" class="chatTime">{{ chatHistory.date }}</h6>
              <div v-if="chatHistory.messageFrom == 1" class="userChat">
                <div class="row">
                  <div class="col-md-1" style="padding-right: 0px;">
                    <img v-if="user.image" :src="user.image" />
                    <img v-else src="/img/userChat.png" />
                  </div>
                  <div class="col-md-6">
                    <h5>{{ user.name }} <span>{{ chatHistory.time }}</span></h5>
                    <p>{{ chatHistory.message }}</p>
                  </div>
                </div>
              </div>
            <!-- <div class="userChat">
              <div class="row">
                <div class="col-md-1" style="padding-right: 0px;">
                  <img src="/img/team-ossie.png"/>
                </div>
                <div class="col-md-6">
                  <h5>Navjot Singh <span>12:25 PM</span></h5>
                  <p>Lorem Ipsum is simply dummy text of the printing</p>
                </div>
              </div>
            </div> -->
            <div v-else class="adminChat">
              <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <h5>Admin <span>{{ chatHistory.time }}</span></h5>
                  <p>{{ chatHistory.message }}</p>
                </div>
              </div>
            </div>
            </div>
            <div class="chatMessage">
              <textarea type="text" v-model="message" placeholder="Write your message..."></textarea>
              <span><input type="checkbox" v-model="sentOnEmail">Sent on email</span>
              <button :disabled="!message" @click="sendMessage" ><img src="/img/SentIcon.png"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LiveChat',
  data () {
    return {
      message: '',
      sentOnEmail: '',
      activeTab: 'unresolved',
      unresolvedUsers: [],
      AdminData: [],
      chatHistories: [],
      resolvedUsers: [],
      user: {},
      unresolvedCount: '',
      adminCount: '',
      resolvedCount: '',
      ChatStatus: {
        status: ''
      }
    }
  },
  mounted () {
    this.scrollToBottom()
    this.getUserChats()
    this.getUserChatHistory()
  },
  updated () {
    this.scrollToBottom()
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        this.getUserChats()
        this.getUserChatHistory()
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.getUserChats()
    this.getUserChatHistory()
    next()
  },
  methods: {
    scrollToBottom () {
      this.$nextTick(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        })
      })
    },
    getUserChats () {
      this.loadingPickls = true
      this.$http
        .get('chat-users')
        .then((response) => {
          this.unresolvedUsers = response.body.unresolvedUsers
          this.resolvedUsers = response.body.resolvedUsers
          this.AdminData = response.body.AdminData
          this.unresolvedCount = response.body.unresolvedCount
          this.adminCount = response.body.adminCount
          this.resolvedCount = response.body.resolvedCount
          // this.closeChatUsers = response.body.closeChatUsers
        })
        .catch((error) => {
          console.error('Error fetching chats:', error)
        })
        .finally(() => {
          this.loadingPickls = false
        })
    },
    getUserChatHistory () {
      this.$http
        .get('user-chat-history/' + this.$route.params.userId)
        .then((response) => {
          this.chatHistories = response.body.data
          this.user = response.body.user
          this.ChatStatus = response.body.ChatStatus
        })
        .catch((error) => {
          console.error('Error fetching chats:', error)
        })
    },

    async sendMessage () {
      if (!this.message.trim()) return
      this.loading = true
      try {
        await this.$http.post(`admin-chat-reply/${this.user.id}`, {
          message: this.message, sentOnEmail: this.sentOnEmail
        })
        this.message = ''
        this.getUserChatHistory()
        this.$emit('message-sent')
      } catch (error) {
        console.error('Error sending chat reply:', error)
      } finally {
        this.loading = false
      }
    },

    async MarkAsResolved () {
      this.loading = true
      try {
        await this.$http.post(`mark-as-resolved/${this.user.id}`)
        this.unresolvedCount = response.body.ongoingCount
        this.resolvedCount = response.body.closeChat
        this.ChatStatus.status = response.body.chatStatus
        location.reload()
      } catch (error) {
        console.error('Error sending chat reply:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style>
.chat-index h3 img{
    width: 30px;
    float: right;
    margin-top: 6px;
}
.chat-padd {
    padding: 0px;
}
.chat-sidebar {
    background: #fff;
    height: 100vh;
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.6);
    padding: 30px 10px 10px 10px;
}
.chat-index h3 {
    margin-top: 0px;
    color: #000;
    font-size: 28px;
    font-weight: 800;
    position: relative;
}
.chat-sidebar input{
    background: #ECEFF2;
    border: 0px;
    border-radius: 20px;
    height: 40px;
    font-size: 15px;
    padding-left: 40px;
    margin-top: 10px;
    margin-bottom: 5px;
}
.chat-sidebar h3::after{
    position: absolute;
    z-index: 1;
    content: "";
    background-image: url('/img/SearchChat.png');
    width: 21px;
    height: 21px;
    left: 10px;
    bottom: -52px;
    background-size: 100%;
}
.chat-sidebar .col-md-3 img{
    border-radius: 50%;
    width: 65px;
    height: 65px;
}
.ongoing-con {
    font-size: 14px;
    float: left;
    margin-right: 14px;
    background: #ECEFF2;
    padding: 10px 12px;
    border-radius: 12px;
    cursor: pointer;
}
.chatBox{
    margin-bottom: 15px;
    padding: 5px 10px;
    border-radius: 18px;
}
.chatBox:hover,
.chatBox.active{
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.4);
}
.chatBox h5{
    font-size: 16px;
    color: #000;
    margin-bottom: 5px;
}
.chatBox h6{
    margin-top: 0px;
    font-size: 14px;
    color: #555;
}
.chatHeader {
    padding: 7px 15px;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.6);
}
.chatHeader h4{
    margin-top: 20px;
    color: #000;
    font-size: 20px;
    margin-bottom: 5px;
}
.chatHeader h6{
    margin-top: 0px;
    font-size: 14px;
}
.chatHeader button {
    background: #B2CEB3;
    color: #000;
    border: 0px;
    margin-right: 25px;
    padding: 7px 20px;
    border-radius: 16px;
    font-size: 15px;
    margin-top: 22px;
}
.userChat {
    padding-left: 25px;
    padding-top: 20px;
    margin-top: 5px;
}
.chatList {
    background: #F2F3F7;
    min-height: 530px;
    margin-left: 4px;
    padding-bottom: 80px;
    padding-top: 100px;
}
.userChat p{
    background: #fff;
    padding: 10px 20px;
    border-radius: 13px;
    font-size: 15px;
    box-shadow: 2px 0px 2px rgba(0, 0, 0, 0.1);
}
.userChat img,
.adminChat img {
    margin-top: 26px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
}
.userChat h5{
    font-size: 15px;
    color: #000;
    margin-bottom: 5px;
}
.userChat h5 span{
    color: #969696;
    font-size: 11px;
    font-weight: normal;
}
.adminChat p{
    background: #782B55;
    padding: 10px 20px;
    border-radius: 13px;
    color: #fff;
    font-size: 15px;
    box-shadow: 2px 0px 2px rgba(0, 0, 0, 0.1);
}
.adminChat h5{
    font-size: 15px;
    color: #000;
    margin-bottom: 5px;
    text-align: right;
}
.adminChat h5 span{
    color: #969696;
    font-size: 11px;
    font-weight: normal;
}
.adminChat {
    padding-right: 20px;
}
.chatTime {
    text-align: center;
    display: block;
    z-index: 9;
    position: relative;
    padding-top: 15px;
    margin-top: 4px;
}
.chatTime:after{
    width: 96%;
    height: 1px;
    position: absolute;
    background: #C3C3C3;
    z-index: -3;
    content: "";
    left: 2%;
    top: 21px;
}
.chatTime::before{
    content: "";
    position: absolute;
    width: 120px;
    height: 30px;
    background: #F2F3F7;
    z-index: -1;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 15px;
}
.chat-sidebar {
    position: fixed;
    width: 26%;
    overflow-y: scroll;
    padding-bottom: 40px;
}
::-webkit-scrollbar {
  width: 0px;
}
.chatMessage textarea{
    margin-bottom: 0px;
    border: 0px;
    width: 96%;
    margin-left: 2%;
    border-radius: 13px;
    resize: none;
    font-size: 15px;
    margin-top: 20px;
    position: fixed;
    bottom: 10px;
    right: 20px;
    width: 50%;
    padding: 12px 20px 20px 15px;
    height: 80px;
}
.chatMessage button{
    position: fixed;
    right: 30px;
    bottom: 20px;
    border: 0px;
    background: #3A5B3C;
    width: 56px;
    height: 56px;
    border-radius: 50%;
}
.chatMessage button img{
    width: 35px;
}
.chatMessage button:disabled{
    background: #B2CEB3 !important;
}
.userRep {
    width: 8px;
    height: 8px;
    background: #12DA6D;
    display: inline-block;
    border-radius: 50%;
    margin-right: 3px;
}
.chatHeader {
    position: fixed;
    right: 0px;
    width: 53%;
    z-index: 999999;
    background: #fff;
}
/* .chatMessage {
    position: relative;
} */
.chatMessage span {
    position: fixed;
    bottom: 20px;
    left: 49.5%;
    font-size: 14px;
}
.chatMessage span input{
    width: 15px;
    height: 15px;
}
.chat-index {
    background: #F2F3F7;
    min-height: 100vh;
}
.actTab{
    background: #782b54;
    color: #fff;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #4caf50;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

</style>
